import React, { useCallback } from 'react'
import List from '@commonComponents/List'
import AdditionalDocForm from '@EUForms/additionalDocForm'
import { useSelector } from 'react-redux'
import { selectAdditionalDocList } from '@EUForms/selectors'
import { useCurrentShipmentType } from '@hooks/useCurrentShipmentType'

const AdditionalDocDetail = ({ isDisabled, dataSource, ...rest }) => {
  const docTypeList = useSelector(selectAdditionalDocList)
  const dropdownListTra = docTypeList?.filter((item) => item?.additionalInfo === 'TRA')
  const renderItem = useCallback(
    (item) => (
      <AdditionalDocForm
        dataSource={item}
        key={item.id}
        docTypeList={dropdownListTra}
        {...rest}
        isDisabled={isDisabled}
      />
    ),
    [rest,isDisabled, dropdownListTra]
  )

  return <List className='responsiveGridCss' dataSource={dataSource} renderItem={renderItem} />
}

export default React.memo(AdditionalDocDetail)
